import { PaymentProfileRestrictionSettingsCodes } from '../entities';

export const restrictionsKnown = [
    PaymentProfileRestrictionSettingsCodes.DailyLimit,
    PaymentProfileRestrictionSettingsCodes.IntervalBetweenOrders,
    PaymentProfileRestrictionSettingsCodes.MaxActiveOrders,
    PaymentProfileRestrictionSettingsCodes.MaxDailyOrders,
    PaymentProfileRestrictionSettingsCodes.MaxOrderAmount,
    PaymentProfileRestrictionSettingsCodes.MinOrderAmount
];
